// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImagePlaceholder__container-f5bd65 {
  flex-shrink: 0;
  border-radius: 16px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Placeholders/ImagePlaceholder/ImagePlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  flex-shrink: 0;\n  border-radius: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ImagePlaceholder__container-f5bd65`
};
module.exports = ___CSS_LOADER_EXPORT___;
